import { render, staticRenderFns } from "./course-category.vue?vue&type=template&id=efa05bd4&scoped=true"
import script from "./course-category.vue?vue&type=script&lang=js"
export * from "./course-category.vue?vue&type=script&lang=js"
import style0 from "./course-category.vue?vue&type=style&index=0&id=efa05bd4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa05bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa05bd4')) {
      api.createRecord('efa05bd4', component.options)
    } else {
      api.reload('efa05bd4', component.options)
    }
    module.hot.accept("./course-category.vue?vue&type=template&id=efa05bd4&scoped=true", function () {
      api.rerender('efa05bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/course-category.vue"
export default component.exports